import { FC } from 'react';
import { Text } from '@connect-x-app/hybrid-ui';
import { COLORS } from '@connect-x-app/shared-ui';

import { Icon } from '../icon';

import './banner.scss';

type BannerAction = {
  label: string;
  onClick: () => void;
  testId?: string;
};

type Props = {
  action?: BannerAction;
  message: string;
  showIcon?: boolean;
  variant?: 'default' | 'accent';
};

export const Banner: FC<Props> = ({ action, message, showIcon = true, variant = 'default' }) => {
  const isAccent = variant === 'accent';

  return (
    <div className={`banner-container${isAccent ? ' banner-container--accent' : ''}`}>
      {showIcon ? <Icon colorName={COLORS.zulu.$08} name="circularInfoOutline" size={2.4} /> : null}
      <Text
        as="p"
        color={isAccent ? COLORS.zulu.$10 : COLORS.zulu.$08}
        size="SM"
        uppercase={isAccent}
        weight={isAccent ? 'bold' : 'regular'}
      >
        {message}
      </Text>
      {action ? (
        <button className="banner-container--action" data-test={action.testId} onClick={action.onClick}>
          <Text color={COLORS.yuma.$01} size="SM" weight="bold">
            {action.label}
          </Text>
        </button>
      ) : null}
    </div>
  );
};
